import { useIndexedDB } from "react-indexed-db-hook";
import { useEffect, useState } from "react";
import { IVehicle } from "types/vehiclePicker.type";

export default function useVehiclesState() {
    const dbValues = useIndexedDB("vehicles");
    const { getAll, add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, getByID } = dbValues;

    const [vehicles, setVehicles] = useState<IVehicle[]>([]);

    const reload = () => {
        getAll()
            .then((valuesFromDB: IVehicle[]) => {
                setVehicles(valuesFromDB);
            })
            .catch(() => setVehicles([]));
    };

    useEffect(() => {
        reload();
    }, [dbValues]);

    const getByIndex = (indexName: keyof IVehicle, key: any): IVehicle => {
        if (indexName === "id") {
            key = parseInt(key);
        }
        return vehicles.find((vehicle) => vehicle[indexName] === key);
    };

    const deleteByIndex = async (indexName: keyof IVehicle, key: any) => {
        if (indexName === "id") {
            await deleteRecord(parseInt(key));
        } else {
            const entity = await _getByIndex(indexName, key);
            await deleteRecord(entity.id);
        }
        reload();
    };

    return { vehicles, add, deleteRecord, getByIndex, getByIndexAsync: _getByIndex, deleteByIndex, clearAll, reload };
}
